// extracted by mini-css-extract-plugin
module.exports = {"selectModeDiv":"styles_selectModeDiv__1piPr","nextButton":"styles_nextButton__1kB5g","ant-btn-primary":"styles_ant-btn-primary__3Fr7E","backButton":"styles_backButton__3N0TK"};